import Swiper from "swiper";

const imageSlider = document.querySelector(".image-gallery-slider");
if (imageSlider) {
  const swiper = new Swiper(imageSlider, {
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
